import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const END_KEY = 'lumiere_offer_end_v1';
const TWELVE_HOURS = 12 * 60 * 60 * 1000;

const useCountdown = () => {
  const end = useMemo(() => {
    let e = parseInt(localStorage.getItem(END_KEY) || '0', 10);
    if (!e || e < Date.now()) {
      e = Date.now() + TWELVE_HOURS;
      localStorage.setItem(END_KEY, String(e));
    }
    return e;
  }, []);
  const [remaining, setRemaining] = useState(end - Date.now());
  useEffect(() => {
    const t = setInterval(() => setRemaining(Math.max(0, end - Date.now())), 1000);
    return () => clearInterval(t);
  }, [end]);
  const hours = Math.floor(remaining / 3.6e6);
  const mins = Math.floor((remaining % 3.6e6) / 6e4);
  const secs = Math.floor((remaining % 6e4) / 1000);
  return { hours, mins, secs };
};

export const CountdownBanner = () => {
  const { hours, mins, secs } = useCountdown();
  const pad = (n) => String(n).padStart(2, '0');

  return (
    <section className="bg-lum-orange/90 text-lum-text">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-14 grid grid-cols-1 md:grid-cols-12 items-center gap-6">
        <div className="md:col-span-7">
          <p className="overline">Flash Ritual · Today only</p>
          <h3 className="font-serif-display text-3xl md:text-5xl mt-2 leading-[1.05]">
            10% off when you stack 2 packs.<br className="hidden md:block" /> Free gift with every order.
          </h3>
        </div>
        <div className="md:col-span-5 flex flex-col md:items-end gap-4">
          <div data-testid="countdown-timer" className="flex gap-3 font-serif-display">
            {[{ l: 'Hrs', v: pad(hours) }, { l: 'Min', v: pad(mins) }, { l: 'Sec', v: pad(secs) }].map((b) => (
              <div key={b.l} className="bg-lum-bg/80 px-5 py-3 min-w-[72px] text-center">
                <p className="text-3xl md:text-4xl leading-none">{b.v}</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-lum-text2 mt-1">{b.l}</p>
              </div>
            ))}
          </div>
          <Link to="/shop" data-testid="countdown-shop-button" className="btn-primary">Shop the Flash</Link>
        </div>
      </div>
    </section>
  );
};
